import React from 'react';

export default class TwitterFollowButton extends React.Component {
  static propTypes = {
    username: React.PropTypes.string.isRequired,
  };

  render() {
    return (
      <a href={`https://twitter.com/${this.props.username}`}
        style={{ textDecoration: 'none' }}>@{this.props.username}</a>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./ui/_TwitterFollowButton.jsx
 **/